<template>
  <div class="section">
    <div class="content">
      <h1>Topics</h1>


      <a href="" class="button is-info m-4">Monitor new topic</a>

      <table class="table is-striped">

        <thead>
        <tr>
          <th>Title</th>
          <th>Alerts</th>
          <th>Created</th>
          <th>Last update</th>
          <th>Monitored channels</th>


        </tr>
        </thead>
        <tbody>
        <tr v-for="(row,idx) in topics" :key="'r'+idx" style="height: 60px;">
          <td>
            <router-link :to="{name:'Topic', 'params':{topicId:idx}}">{{ row.title }}</router-link>
          </td>
          <td>
            <router-link v-if="row.alerts.length>0" :to="{name:'Topic', 'params':{topicId:idx}}">
              <button class="button is-danger">Check alerts ({{ row.alerts.length }})</button>
            </router-link>
            <span v-else>No alerts</span>

          </td>
          <td>{{ row.created }}</td>
          <td>{{ row.last_update }}</td>
          <td>{{ getChannelNames(row.data_source) }}</td>


        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex'

export default {
  components: {},

  data() {
    return {}
  },
  computed: {
    ...mapState({
      topics: 'topics'
    }),

  },

  methods: {
    getChannelNames(data_source) {
      let buffer = [];
      data_source.forEach(item => {
        buffer.push(item.name);
      })

      return buffer.join('; ');
    },
  }
}


</script>
